import { MutationCache, QueryCache, QueryClient } from 'react-query';

import { useHandleHttpErrors } from './useHandleHttpErrors';

const defaultQueryConfig = { staleTime: 60000 };

export const useQueryClientt = () => {
  const { handleHttpErrors } = useHandleHttpErrors();

  const queryClient = new QueryClient({
    defaultOptions: { queries: defaultQueryConfig },
    queryCache: new QueryCache({
      onError: (error: unknown) => handleHttpErrors(error),
    }),
    mutationCache: new MutationCache({
      onError: (error: unknown) => handleHttpErrors(error),
    }),
  });
  return queryClient;
};
